import React, { useRef, useState, useEffect } from "react";
import { Row, Col, Typography, Divider, message, notification } from "antd";
import { Colors } from "theme";
import { MdArrowDropDownCircle } from "react-icons/md";
import Table from "./NewTable";
import PageTitle from "./PageTitle";
import BreadcrumbComponent from "./Breadcrumb";
import StickyBox from "react-sticky-box";
import API_KEY from "api";
import { randomString } from "../../../../utils/randomString";
import { useHistory, useLocation } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import axios from "axios";
import { CloseOutlined } from "@ant-design/icons";
import FieldsModal from "./FieldsModal";
import EmptyState from "./EmptyState";
const { Text } = Typography;
export default function CategoryTabs({
  tableData,
  collectionDetails,
  collectionId,
  type,
  showInternals,
  setShowInternals,
  setSaving,
  saving,
  setTableData,
  refreshCollection,
}) {
  const tabRef = useRef([]);
  const history = useHistory();
  const location = useLocation();
  const [visibleAtrributes, setVisibleAtrributes] = useState([]);
  const [productIds, setProductIds] = useState([]);
  const [fieldsModalVisible, setFieldsModalVisible] = useState(false);
  const [genarateCatalogoueModalVisible, setGenarateCatalogoueModalVisible] =
    useState(false);
  const [showTour, setShowTour] = useState(false);
  const [continueButtonLoading, setContinueButtonLoading] = useState(false);

  // useEffect(() => {
  //   if (tableData) {

  //    const newData = tableData.map(cat => {
  //       return {...cat,values:cat.values.map(product => {
  //         return {...product , attributes:product.attributes.map(attr => {
  //           return {...attr,visible: product?.visible_attributes?.includes(`${attr.attribute_id}`)}
  //         })}
  //       })}
  //     })

  //     // setTableData(newData)
  //     setTableData(newData);
  //   }
  // }, []);

  useEffect(() => {
    // console.log(location,'location');
    const newItem = localStorage.getItem("new");

    if (newItem === "true") {
      setFieldsModalVisible(true);
    }
    // if(location.state?.type === "edit"){
    //   setFieldsModalVisible(false);
    // }
    // else{
    //   setFieldsModalVisible(true);
    // }
  }, [location]);

  const attributesVisibility =
    tableData?.length > 0
      ? tableData.map((item) => ({
          keys: item?.values?.map((value) => value?.collection_product_id),
          data: {
            // visible_attributes: item?.values
            //   ?.map((attr) =>
            //     attr?.visible_attributes?.length > 0
            //       ? Array.from(new Set(attr?.visible_attributes)).join(",")
            //       : Array.from(
            //           new Set(
            //             item?.values
            //               ?.flatMap((value) => value?.attributes)
            //               .map((i) => i?.attribute_id)
            //           )
            //         )
            //   )
            //   .join(","),
            visible_attributes:
              item?.values?.[0]?.visible_attributes &&
              item?.values?.[0]?.visible_attributes?.length > 0
                ? item?.values?.[0]?.visible_attributes.join(",")
                : Array.from(
                    new Set(
                      item?.values
                        ?.flatMap((value) => value?.attributes)
                        .map(
                          (i) =>
                            i?.is_internal === false &&
                            i?.visible === true &&
                            i?.attribute_id
                        )
                    )
                  ).join(","),
          },
        }))
      : [];

  const saveAsDraft = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    const payload = {
      status: "draft",
    };

    setSaving(true);
    // save collection status
    API_KEY.URL.patch(`${API_KEY.path.collections}/${collectionId}`, payload)
      .then((res) => {
        setSaving(false);
        message.success("Collection saved as draft");
      })
      .catch((err) => {
        setSaving(false);
        console.log(err);
      });
    axios
      .post(
        `${process.env.REACT_APP_API_SERVICE}items/collection_products?token=${user?.access_token}`,
        attributesVisibility
      )
      .then((res) => setSaving(false))
      .catch((err) => setSaving(false));

    // API_KEY.URL.post("${process.env.REACT_APP_API_SERVICE}items/collection_products", {data:attributesVisibility})
    //   .then((res) => setSaving(false))
    //   .catch((err) => setSaving(false));
  };

  const validator = async () => {
    const user = JSON.parse(localStorage.getItem("user"));

    // save visible attributes
    setSaving(true);
    setContinueButtonLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_SERVICE}items/collection_products?token=${user?.access_token}`,
        attributesVisibility
      )
      .then((res) => {
        setSaving(false);
        
        if (res.status === 200) {
          axios
            .get(
              `${process.env.REACT_APP_API_SERVICE}validator/table/collection_products?collection_id=${collectionId}&token=${user?.access_token}`
            )
            .then((res) => {
              const data = res.data;
              setContinueButtonLoading(false);

              if (Object.keys(data).length > 0) {
                const keys = Object.keys(data);

                notification.error({
                  message: (
                    <h4 style={{ color: "white" }}>
                      Currency or Unit not selected
                    </h4>
                  ),
                  description: `You have not selected currency or unit for ${keys.join(
                    ","
                  )}.`,
                  closeIcon: (
                    <CloseOutlined style={{ color: "white", fontSize: 20 }} />
                  ),
                  style: {
                    color: "white",
                    background: "rgb(0,0,0,0.9)",
                    borderRadius: 8,
                  },
                });
                setContinueButtonLoading(false);
                setGenarateCatalogoueModalVisible(false);
                // return false;
              } else {
                setContinueButtonLoading(false);
                setGenarateCatalogoueModalVisible(true);
                // update collection info
                // return true;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        setSaving(false);
        setContinueButtonLoading(false);
        console.log(err);
      });
  };

  const handleContinue = (values) => {
    values.collection_link =
      collectionDetails?.collection_link || randomString(7);
    values.status = "published";
    values.visible_attributes = visibleAtrributes
      .filter((item) => item?.visible === true && item?.is_internal === false)
      .map((attr) => attr?.id);

    setSaving(true);
    API_KEY.URL.patch(
      `${API_KEY.path.collections}/${collectionDetails?.id}`,
      values
    )
      .then((response) => {
        if (response.status === 200) {
          localStorage.removeItem("selectedProducts");
          localStorage.removeItem("new");
          history.push(
            `/collection-link/${response.data?.data?.collection_link}`
          );
        }
        API_KEY.URL.get(
          `${API_KEY.path.catalogue_created}/${collectionDetails?.id}`
        ).then((res) => console.log("catalogue shared"));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePreview = (values, callback) => {
    API_KEY.URL.patch(
      `${API_KEY.path.collections}/${collectionDetails?.id}`,
      values
    )
    .then((response) => {
      if (response.status === 200) {
         callback()
       } 
     })
  };

  return (
    <div>
      <FieldsModal
        collectionDetails={collectionDetails}
        setFieldsModalVisible={setFieldsModalVisible}
        isVisible={fieldsModalVisible}
        data={tableData}
        setTableData={setTableData}
        setSaving={setSaving}
        setShowTour={setShowTour}
      />
      {/* <span style={{position:'fixed',zIndex:100, width:'92.5%',background:'white',top:64,paddingTop:"1rem"}} >  */}

      <StickyBox
        offsetTop={64}
        offsetBottom={24}
        style={{ zIndex: 100, background: "white", paddingTop: "1em" }}
      >
        <BreadcrumbComponent collectionId={collectionId} type={type} />
        <PageTitle
          tableData={tableData}
          collectionDetails={collectionDetails}
          showInternals={showInternals}
          setShowInternals={setShowInternals}
          saving={saving}
          saveAsDraft={saveAsDraft}
          handleContinue={handleContinue}
          handlePreview={handlePreview}
          collectionId={collectionId}
          history={history}
          validator={validator}
          genarateCatalogoueModalVisible={genarateCatalogoueModalVisible}
          setGenarateCatalogoueModalVisible={setGenarateCatalogoueModalVisible}
          setFieldsModalVisible={setFieldsModalVisible}
          showTour={showTour}
          setShowTour={setShowTour}
          setContinueButtonLoading={setContinueButtonLoading}
          continueButtonLoading={continueButtonLoading}
        />
        <br />
        <Row align="middle">
          {tableData?.map((category, index) => (
            <Col
              key={index}
              onClick={() =>
                tabRef.current[index].scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                })
              }
            >
              <Row justify="space-between">
                <Col>
                  {" "}
                  <Text>
                    {" "}
                    {`${category?.values?.length} ${category?.name}`}{" "}
                  </Text>
                </Col>
                <Col>
                  <Text style={{ color: Colors.primaryColor, marginLeft: 5 }}>
                    View
                  </Text>
                </Col>
                <Col>
                  {/* <MdKeyboardArrowDown size={22} style={{ color: Colors.primaryColor }} /> */}
                </Col>
                <Divider type="vertical" style={{ marginTop: "5px" }} />
              </Row>
              {/* <Text
                type="secondary"
                style={{fontSize:14,display:'inline-block',verticalAlign:'center'}}
                
              >
                <Text> {`${category?.values?.length} ${category?.name}`} </Text>
                <Text style={{ color: Colors.primaryColor }} >
                  View  
                </Text>
                <MdKeyboardArrowDown size={20}  />
              </Text> */}
            </Col>
          ))}
        </Row>
        <Divider />
      </StickyBox>
      {/* </span> */}

      {tableData?.length === 0 && (
        <EmptyState history={history} collectionId={collectionId} />
      )}

      {/* <span style={{position:'relative',top:140}} > */}
      {tableData?.map((category, index) => (
        <span
          key={JSON.stringify(category?.values)}
          ref={(el) => (tabRef.current[index] = el)}
        >
          <Row>
            <Col span={24}>
              <Table
                collectionDetails={collectionDetails}
                setSaving={setSaving}
                categoryId={category?.id}
                category={category}
                tableData={category?.values}
                showInternals={showInternals}
                collectionId={collectionId}
                setVisibleAtrributes={setVisibleAtrributes}
                setTableData={setTableData}
                refreshCollection={refreshCollection}
                setProductIds={setProductIds}
              />
              <Divider />
            </Col>
          </Row>
        </span>
      ))}
      {/* </span> */}
    </div>
  );
}
